module.exports = __webpack_public_path__ + "img/overview1.03df1edf.jpg";